import React, { useState, ChangeEvent } from "react";
import {
    Container,
    AppBar,
    Toolbar,
    Typography,
    InputBase,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Divider,
    alpha,
    styled,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { blogPosts, BlogPost } from "../data/BlogEntry";
import ArticleIcon from "@mui/icons-material/Article";

const Search = styled("div")(({ theme }) => ({
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.primary.main, 0.15),
    "&:hover": { backgroundColor: alpha(theme.palette.primary.main, 0.25) },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: { marginLeft: theme.spacing(1), width: "auto" },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: theme.palette.primary.main,
    "& .MuiInputBase-input": {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create("width"),
        width: "12ch",
        "&:focus": { width: "20ch" },
    },
}));

const BlogPage: React.FC = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredPosts, setFilteredPosts] = useState(blogPosts);

    const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
        const term = e.target.value.toLowerCase();
        setSearchTerm(term);
        setFilteredPosts(
            blogPosts.filter(
                (post) =>
                    post.title.toLowerCase().includes(term) ||
                    post.content.toLowerCase().includes(term)
            )
        );
    };

    return (
        <Container sx={{ py: 8 }}>
            <AppBar position="static">
                <Toolbar sx={{ backgroundColor: "#111" }}>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        What I have been thinking about...
                    </Typography>
                    <Search>
                        <SearchIconWrapper>
                            <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase
                            placeholder="Search…"
                            value={searchTerm}
                            onChange={handleSearch}
                            inputProps={{ "aria-label": "search" }}
                        />
                    </Search>
                </Toolbar>
            </AppBar>
            <List>
                {filteredPosts.map((post) => (
                    <React.Fragment key={post.url}>
                        <ListItem
                            component="a"
                            href={post.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            button
                        >
                            <ListItem
                                component="a"
                                href={post.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                button
                            >
                                <ListItemIcon>
                                    <ArticleIcon />
                                </ListItemIcon>
                                <ListItemText
                                    primary={post.title}
                                    secondary={
                                        <>
                                            <Typography
                                                component="span"
                                                variant="body2"
                                                color="text.secondary"
                                                sx={{ display: "block" }}
                                            >
                                                {post.content}
                                            </Typography>
                                            <Typography
                                                component="span"
                                                variant="caption"
                                                color="text.secondary"
                                                sx={{ display: "block", mt: 0.5 }}
                                            >
                                                {new Date(post.date).toLocaleDateString()}
                                            </Typography>
                                        </>
                                    }
                                />
                            </ListItem>
                        </ListItem>
                        <Divider />
                    </React.Fragment>
                ))}
            </List>
        </Container>
    );
};

export default BlogPage;
